// extracted by mini-css-extract-plugin
export default {"btn":"ComicButton_btn__xIhj0","click":"ComicButton_click__CN1Z1"};